<template>
 <!-- 底部导航 -->
 <!-- 底部导航组件 BottomNav.vue -->
  <div :class="navClass" >
        <!-- 只在购物车页面时使用 navnexclass 包裹 -->
    <template v-if="isCartPage">
      <div  :class="[isScrolled ? navnexclass : carcss]">
        <a 
          v-for="item in navItems" 
          :key="item.path"
          :href="item.path" 
          class="nav-item"
          :class="{ active: activePath === item.path }"
          @click.prevent="navigateTo(item.path)"
        >
          <div class="nav-icon">{{ item.icon }}</div>
          <div class="nav-text">{{ item.text }}</div>
        </a>
      </div>
    </template>
    
    <!-- 非购物车页面时直接显示导航项，不包裹 navnexclass -->
    <template v-else>
      <a 
        v-for="item in navItems" 
        :key="item.path"
        :href="item.path" 
        class="nav-item"
        :class="{ active: activePath === item.path }"
        @click.prevent="navigateTo(item.path)"
      >
        <div class="nav-icon">{{ item.icon }}</div>
        <div class="nav-text">{{ item.text }}</div>
      </a>
    </template>
  </div>
  </template>
  <script setup>
 
 
 import { computed,onMounted,ref} from "vue";
const isScrolled = ref(false)

import { useRoute, useRouter } from "vue-router/dist/vue-router";

const route = useRoute()
const router = useRouter()
const carcss = ref('bottom-nav')
 
const props = defineProps({
  activePath: {
    type: String,
    default: '/'
  }
})
 
onMounted(() => {
  // 选择一种监听方式：
  // 1. 监听容器滚动
  
  
  // 2. 或者监听窗口滚动
 window.addEventListener('scroll', handleWindowScroll)
})
// 也可以监听窗口滚动
const handleWindowScroll = () => {
  isScrolled.value = window.scrollY > 0
  console.log("isScrolled"+isScrolled.value)
}
const navItems = [
  { path: '/', icon: '🏠', text: '首页' },
  { path: '#/Products/ProductsCategory', icon: '📂', text: '分类' },
  { path: '#/Products/Cart', icon: '🛒', text: '购物车' },
  { path: '#/Users/PersonalCenter', icon: '👤', text: '我的' }
]
const navnexclass = computed(() => {
  if (route.path.includes('/Products/Cart')) {
    carcss.value="bottom-nav-g"
    return 'checkout-bar-next'
  }
  return ''
})
// 判断是否是购物车页面
const isCartPage = computed(() => {
  return route?.path?.includes('/Products/Cart') || false
})
const navClass = computed(() => {
  if (route.path.includes('/Products/Cart')) {
    return 'checkout-bar'
  }
  return 'bottom-nav'
})
const navigateTo = (path) => {
  // 如果是 hash 路由
  if (path.startsWith('#')) {
    window.location.href = path
  } else {
    router.push(path)
  }
}
</script>
<style lang="scss" scoped>
.checkout-bar-next{
    display: flex; justify-content: space-around; padding: 12px 0;
}
         .checkout-bar {
            bottom: auto; 
            top: auto; 
            position: relative;
             border-top: none;  
             border-bottom: 1px solid var(--border-color);
            
           
            left: 0;
            right: 0;
            background-color: var(--bg-primary);
            padding: var(--space-md);
            border-top: 1px solid var(--border-color);
            box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
            z-index: var(--z-index-sticky);
            
        }
        
    
        .bottom-nav {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: space-around;
            background-color: white;
            padding: 10px 0;
            border-top: 1px solid #eee;
            z-index: 100;
        }
          .bottom-nav-g {
              position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            justify-content: space-around;
            background-color: white;
            padding: 10px 0;
            border-top: 1px solid #eee;
            z-index: 100;
        }
        .nav-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-decoration: none;
            color: #666;
            flex: 1;
        }
        
        .nav-item.active {
            color: #4a90e2;
        }
        
        .nav-icon {
            font-size: 20px;
            margin-bottom: 4px;
        }
        
        .nav-text {
            font-size: 12px;
        }
</style>